<template>
  <footer>
    <cookie-law :button-text="$t('buttons.accept')" theme="base sma">
      <div slot="message">
        {{ $t('labels.footer') }}
        <!--<router-link to="legal-notes">En savoir plus</router-link>-->
      </div>
    </cookie-law>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';

export default {
  name: 'PageFooter',
  components: {
    CookieLaw,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@import '../assets/scss/_variables';

.Cookie {
  &.sma {
    background-color: $primary-color !important;
    background-color: var(--primary-color) !important;
    color: #ffffff;
    padding: 0.8em 1.25em;
    opacity: 0.9;
    a {
      color: #ffffff;
      font-weight: bold;
      text-decoration: underline;
      &:hover {
        color: #ffffff;
      }
    }
  }
  &__button {
    background-color: $secondary-color !important;
    background-color: var(--secondary-color) !important;
    border-radius: 2px !important;
    &:hover {
      background-color: lighten($secondary-color, 10%) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue